module.exports = __webpack_public_path__ + "img/tn.31980512.svg";